import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your Firebase config
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app, 'dental-note-data');
export const storage = getStorage(app);

// Expose auth and config on window for quick debugging in DevTools.
// REMOVE THIS BEFORE PRODUCTION — it's only for local debugging.
if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-undef
    window.__appAuth = auth;
    // eslint-disable-next-line no-undef
    window.__firebaseConfig = firebaseConfig;
}
